import albums2025 from './2025';
import albums2023 from './2023';
import albums2022 from './2022';
import albums2021 from './2021';

// Combine all album data
const albumsData = {
  2025: albums2025,
  2023: albums2023,
  2022: albums2022,
  2021: albums2021
};

// Helper functions for year-based navigation
export const getAvailableYears = () => {
  return Object.keys(albumsData)
    .map(year => parseInt(year))
    .sort((a, b) => b - a); // Latest year first
};

// Get all photos for a specific year (no albums)
export const getPhotosForYear = (year) => {
  const albums = albumsData[year] || [];
  const photos = [];
  
  albums.forEach(album => {
    if (album.photos && album.photos.length > 0) {
      photos.push(...album.photos);
    }
  });
  
  return photos;
};

// Get year statistics for year cards
export const getYearStats = (year) => {
  const albums = albumsData[year] || [];
  const totalPhotos = albums.reduce((total, album) => 
    total + (album.photos ? album.photos.length : 0), 0
  );
  
  // Get thumbnail from first available photo (prefer WebP, fallback to JPG)
  let thumbnail = null;
  for (const album of albums) {
    if (album.photos && album.photos.length > 0) {
      const photo = album.photos[0];
      thumbnail = photo.image || photo.fallback || photo.url || album.thumbnail;
      break;
    }
  }
  
  return {
    year,
    albumCount: albums.length,
    photoCount: totalPhotos,
    thumbnail
  };
};

// Get all albums for a specific year
export const getAlbumsForYear = (year) => {
  return albumsData[year] || [];
};

// Get a specific album by ID
export const getAlbumById = (year, albumId) => {
  const albums = albumsData[year] || [];
  return albums.find(album => album.id === parseInt(albumId));
};

// Get photos for a specific album
export const getPhotosForAlbum = (year, albumId) => {
  const album = getAlbumById(year, albumId);
  return album ? (album.photos || []) : [];
};

// Get album statistics (thumbnail is always 1st photo)
export const getAlbumStats = (year, albumId) => {
  const album = getAlbumById(year, albumId);
  if (!album) return null;
  
  // Thumbnail is always the 1st photo (prefer WebP, fallback to JPG)
  const thumbnail = album.photos && album.photos.length > 0 
    ? (album.photos[0].image || album.photos[0].fallback || album.photos[0].url)
    : null;
  
  return {
    album,
    photoCount: album.photos ? album.photos.length : 0,
    thumbnail
  };
};

export default albumsData;